angular.module('MyHippoProducer.Controllers').directive('billingSection', function () {
    return {
        restrict: 'E',
        scope: {},
        templateUrl: 'pages/policy-details/sections/billing/billing.html',
    };
});
